import { Outlet } from "react-router-dom";
import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import ConsentBanner from "@/components/ConsentBanner";
import ProgressBar from "@/components/ProgressBar";
import ScrollToTop from "@/components/ScrollToTop";
import StickyCTA from "@/components/StickyCTA";

export default function Layout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#faf7f2]">
      <ProgressBar />
      <Navigation />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
      <ConsentBanner />
      <ScrollToTop />
      <StickyCTA />
    </div>
  );
}
